import { TutorialStepDef } from "./types";

// 8 step operator tutorial covering first sign-in to first order + mail send.
// Spec source: estfort-consulting-pm #124 (v2.1 — guest step inserted before order).
// i18n keys are placeholders; W5 (#128) fills in JA/EN translations.
export const TUTORIAL_STEPS: TutorialStepDef[] = [
  {
    id: "shop",
    route: "/shop",
    targetSelector: "[data-tutorial='shop-add']",
    titleKey: "tutorial.steps.shop.title",
    descriptionKey: "tutorial.steps.shop.description",
    side: "bottom",
    fallbackTitle: "店舗を追加",
    fallbackDescription: "まず店舗を1つ登録します。",
  },
  {
    id: "cast",
    route: "/cast",
    targetSelector: "[data-tutorial='cast-add']",
    titleKey: "tutorial.steps.cast.title",
    descriptionKey: "tutorial.steps.cast.description",
    side: "bottom",
    fallbackTitle: "キャストを追加",
    fallbackDescription: "次にキャストを登録します。",
  },
  {
    id: "castShift",
    route: "/castShift",
    targetSelector: "[data-tutorial='castshift-add']",
    titleKey: "tutorial.steps.castShift.title",
    descriptionKey: "tutorial.steps.castShift.description",
    side: "bottom",
    fallbackTitle: "シフトを登録",
    fallbackDescription: "キャストの出勤シフトを登録します。",
  },
  {
    id: "guest",
    route: "/guest",
    targetSelector: "[data-tutorial='guest-add']",
    titleKey: "tutorial.steps.guest.title",
    descriptionKey: "tutorial.steps.guest.description",
    side: "bottom",
    fallbackTitle: "顧客を追加",
    fallbackDescription: "受注に紐づく顧客を登録します。",
  },
  {
    id: "order",
    route: "/order",
    targetSelector: "[data-tutorial='order-create']",
    titleKey: "tutorial.steps.order.title",
    descriptionKey: "tutorial.steps.order.description",
    side: "top",
    fallbackTitle: "受注を作成",
    fallbackDescription: "店舗・顧客・キャストを選択して受注を作成します。",
  },
  {
    id: "mail",
    route: "/order",
    targetSelector: "[data-tutorial='mail-send']",
    titleKey: "tutorial.steps.mail.title",
    descriptionKey: "tutorial.steps.mail.description",
    side: "top",
    fallbackTitle: "キャストへメール送信",
    fallbackDescription: "受注情報をキャストへメール通知します。",
  },
  {
    id: "verify",
    route: "/orderList",
    targetSelector: "[data-tutorial='orderlist-first-row']",
    titleKey: "tutorial.steps.verify.title",
    descriptionKey: "tutorial.steps.verify.description",
    side: "top",
    fallbackTitle: "受注一覧で確認",
    fallbackDescription: "作成した受注が一覧に表示されていることを確認します。",
  },
  {
    id: "finish",
    route: "/",
    targetSelector: "[data-tutorial='dashboard']",
    titleKey: "tutorial.steps.finish.title",
    descriptionKey: "tutorial.steps.finish.description",
    side: "bottom",
    fallbackTitle: "チュートリアル完了",
    fallbackDescription: "基本操作の流れは以上です。日々の運用を始めましょう。",
  },
];
